// packages
import { Component } from 'preact';

// internal
import shallowEqual from '../utils/shallow-equal';

abstract class PureComponent<P = {}, S = {}> extends Component<P, S> {
  shouldComponentUpdate(props, state) {
    const check =
      shallowEqual(props, this.props) && shallowEqual(state, this.state);
    // if (props.projection)
    //   console.log(
    //     'projection check:',
    //     props.projection === this.props.projection,
    //     !check
    //   );
    return !check;
  }
}

export default PureComponent;